import {getVotingTrendsExport, getVotingTrendsListActivityExport} from '@/api/votingTrends';
import {generateCSV, slugify} from '@/lib/utils';
import dayjs from 'dayjs';

const HYPHEN_REGEXP = /-/g;

export async function getVotingTrendsCSV(nodeId, nodeName) {
  const blob = await getVotingTrendsExport(nodeId);
  const filename = `ranker_insights_${slugify(nodeName).replace(HYPHEN_REGEXP,'_')}_${dayjs().format('YYYYMMDDHHmmss')}.csv`;
  generateCSV(blob, filename);
}

export async function getVotingTrendsListActivityCSV(nodeId, nodeName, params = {}) {
  const blob = await getVotingTrendsListActivityExport(nodeId, params);
  const filename = `ranker_insights_list_activity_${slugify(nodeName).replace(HYPHEN_REGEXP,'_')}_${dayjs().format('YYYYMMDDHHmmss')}.csv`;
  generateCSV(blob, filename);
}